function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h32v32H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M8 8h16v16H8z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16 24a8 8 0 110-16 8 8 0 010 16z",
  fill: "#2DB35C"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.699 19.261l4.819-4.82a.962.962 0 00-1.359-1.36l-4.14 4.141-2.178-2.179a.962.962 0 00-1.36 1.36l2.858 2.858a.957.957 0 001.36 0z",
  fill: "#fff"
});

var SvgIconStudentStatusDone = function SvgIconStudentStatusDone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiBmaWxsPSJibGFjayIgZmlsbC1vcGFjaXR5PSIwIi8+CjxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0iYmxhY2siIGZpbGwtb3BhY2l0eT0iMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOCA4KSIvPgo8cGF0aCBkPSJNMTYgMjRDMTEuNTgxNiAyNCA4IDIwLjQxODQgOCAxNkM4IDExLjU4MTYgMTEuNTgxNiA4IDE2IDhDMjAuNDE4NCA4IDI0IDExLjU4MTYgMjQgMTZDMjQgMjAuNDE4NCAyMC40MTg0IDI0IDE2IDI0WiIgZmlsbD0iIzJEQjM1QyIvPgo8cGF0aCBkPSJNMTUuNjk4OSAxOS4yNjEyTDIwLjUxNzkgMTQuNDQwNkMyMC44OTQ4IDE0LjA2NTIgMjAuODkzOCAxMy40NTY2IDIwLjUxNzkgMTMuMDgxMUMyMC4xNDM0IDEyLjcwNjIgMTkuNTMzOSAxMi43MDYyIDE5LjE1OSAxMy4wODExTDE1LjAxOTIgMTcuMjIyTDEyLjg0MTIgMTUuMDQzNEMxMi40NjU4IDE0LjY2ODUgMTEuODU2NyAxNC42Njg1IDExLjQ4MTggMTUuMDQzNEMxMS4xMDYzIDE1LjQxODggMTEuMTA2MyAxNi4wMjg0IDExLjQ4MTggMTYuNDAyOUwxNC4zMzk1IDE5LjI2MTJDMTQuNTI3NSAxOS40NDkyIDE0Ljc3MzEgMTkuNTQyOSAxNS4wMTkyIDE5LjU0MjlDMTUuMjY1MyAxOS41NDI5IDE1LjUxMSAxOS40NDkyIDE1LjY5ODkgMTkuMjYxMloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgIconStudentStatusDone as ReactComponent };